import { render, staticRenderFns } from "./MXLXSPMO.vue?vue&type=template&id=0b7c2c85&scoped=true"
import script from "./MXLXSPMO.vue?vue&type=script&lang=js"
export * from "./MXLXSPMO.vue?vue&type=script&lang=js"
import style0 from "./MXLXSPMO.vue?vue&type=style&index=0&id=0b7c2c85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c2c85",
  null
  
)

export default component.exports